export const Heading_Section_Gen_Ai_Development_Services = {
    heading: "AI + YOUR PRODUCT CAN"
  }
  
  export interface IGenAiDevelopmentServicesStatItem {
    labelLines: string[];
    suffix: string;
    value: string;
  }
  
  export const Stats_Section_Gen_Ai_Development_Services: IGenAiDevelopmentServicesStatItem[] = [
    {
      value: "+40",
      suffix: "%",
      labelLines: ["Increase in Feature Adoption"],
    },
    {
      value: "4",
      suffix: "x",
      labelLines: ["Faster User Workflows"],
    },
    {
      value: "-50",
      suffix: "%",
      labelLines: ["Drop in Support Requests"],
    },
  ];
  